import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/context/LangContext";
import { ProductCard, ProductCardSkeleton } from "@/components/ProductCard";
import { Heart } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function Wishlist() {
  const { t } = useLang();
  const { user } = useAuth();
  const [items, setItems] = useState(null);

  useEffect(() => { api.get("/wishlist").then((r) => setItems(r.data)); }, [user?.wishlist?.length]); // eslint-disable-line

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10">
      <h1 className="font-display font-extrabold text-3xl tracking-tight mb-8 flex items-center gap-2"><Heart className="w-7 h-7 fill-mango-600 text-mango-600" /> {t("my_wishlist")}</h1>
      {items === null ? (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">{Array.from({ length: 4 }).map((_, i) => <ProductCardSkeleton key={i} />)}</div>
      ) : items.length === 0 ? (
        <div className="py-20 text-center" data-testid="wishlist-empty">
          <Heart className="w-14 h-14 mx-auto text-stone-300 mb-4" />
          <p className="text-stone-400 mb-4">{t("wishlist_empty")}</p>
          <Link to="/catalog"><Button className="rounded-full bg-emerald-800 hover:bg-emerald-900">{t("continue_shopping")}</Button></Link>
        </div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-testid="wishlist-grid">
          {items.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
        </div>
      )}
    </div>
  );
}
